import React from 'react';

import {FBCommentQuestionToolTip} from 'components/break/tooltips/breaks-steps-section-tool-tips';
import {
    PinterestHeadlineToolTip,
    PinterestIntroCopyToolTip,
    PinterestDisplayTypeToolTip,
    PinterestPinIDsToolTip,
    PinterestBoardURLToolTip
} from 'components/break/tooltips/pinterest-tool-tips';
import {FormattedMessage, IntlProvider} from 'react-intl';
import {enUSmessage} from 'i18n/en-US.js';

export default {
    name: 'pinterest',
    subSection: true,
    resource: true,
    hideIfResourceIsNoU: true,

    fields: [
        {
            type: 'contenteditable',
            name: 'headline',
            required: true,
            // Headline is only allowed if there is more than one step
            showField: (proxy) => (proxy.currentBaseResource.steps && proxy.currentBaseResource.steps.length > 1),
            linkedField: (formProxy) => ["title"],
            props: {
                labelKey: 'editbreak.steps.pinterest.headline',
                helpContent: <PinterestHeadlineToolTip/>,
                helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'tooltips.break.pinterest.headline'}/></IntlProvider>
            }
        },
        {
            type: 'contenteditable',
            name: 'introCopy',
            required: false,
            props: {
              labelKey: 'editbreak.steps.pinterest.intro_copy',
              maxLength: 500,
              placeholderKey: 'editbreak.steps.pinterest.intro_copy.placeholder',
              validationRules: [
                  {
                      type: 'MarkupTextLimit',
                      params: {
                          limit: 500
                      }
                  }
              ],
              helpContent: <PinterestIntroCopyToolTip/>,
              helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'tooltips.break.pinterest.intro_copy'}/></IntlProvider>
            }
        },
        {
            type: 'contenteditable',
            name: 'bodyCopy',
            required: false,
            props: {
              labelKey: 'editbreak.steps.pinterest.body_copy',
              placeholderKey: 'editbreak.steps.pinterest.body_copy.placeholder'
            }
        },
        {
            type: 'text',
            name: 'commentQuestion',
            showField: (proxy) => (proxy.currentBaseResource.showFBComments && proxy.currentBaseResource.sponsoredType !== 'sponsored' ),
            props: {
                labelKey: 'editbreak.steps.related_breaks.commentQuestion',
                helpContent: <FBCommentQuestionToolTip/>,
                helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'tooltips.break.breaks_steps.fbCommentQuestion'}/></IntlProvider>
            }
        },
        {
          type: 'radio',
          name: 'widgetType',
          required: true,
          props: {
            labelKey: 'editbreak.steps.pinterest.display_type',
            options: [
              {
                value: 'PINS',
                textKey: 'editbreak.steps.pinterest.display_type.pins'
              },
              {
                value: 'BOARD',
                textKey: 'editbreak.steps.pinterest.display_type.board'
              }
            ],
            helpContent: <PinterestDisplayTypeToolTip/>,
            helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'tooltips.break.pinterest.display_type'}/></IntlProvider>
          }
        },
        {
          type: 'textarea',
          name: 'pinIds',
          required: true,
          showField: (proxy) => (proxy.currentResource.widgetType === 'PINS'),
          props: {
            labelKey: 'editbreak.steps.pinterest.pin_ids',
            helpContent: <PinterestPinIDsToolTip/>,
            helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'tooltips.break.pinterest.pin_ids'}/></IntlProvider>
          }
        },
        {
          type: 'text',
          name: 'boardId',
          required: true,
          showField: (proxy) => (proxy.currentResource.widgetType === 'BOARD'),
          props: {
            labelKey: 'editbreak.steps.pinterest.board_url',
            helpContent: <PinterestBoardURLToolTip/>,
            helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'tooltips.break.pinterest.board_url'}/></IntlProvider>
          }
        }
    ]
}



// WEBPACK FOOTER //
// ./public/components/EditContent/configs/breaks/steps/pinterest.js